import { createApp } from 'vue'
import App from '@/App.vue'
import { createVuestic } from 'vuestic-ui'
import 'vuestic-ui/css'
import '@/assets/styles/overrides.css'
import router from '@/router'
import stores from '@/stores'

const app = createApp(App).use(createVuestic())
app.use(stores)
app.use(router)
app.mount('#app')
